import { gql } from "@stadium/services/apollo-client";

import { PRODUCT_OPTION_TYPES } from "@graphql/fragments/product/option-types";
import { OPTION_VALUES } from "@graphql/fragments/product/option-values";

export const KIT_PRODUCT_ADDITIONAL_DETAILS = gql`
  fragment KitProductAdditionalDetails on BundleProduct {
    product {
      id: currentStoreIdWithId
      name
      amountIn(currency: $currency)
      priceIn(currency: $currency)
      sizeChartEnabled
      sizeChartLink
      sizeChart
      outOfStock
      intent
      askForRestriction
      askForPreference
      askForPreferenceMessage
      slug
      bulkAvailable
      hasTierPricing
      trackInventory
      masterVariant {
        ... on Variant {
          id
          externalId
          priceIn(currency: $currency)
          images(storeNumber: $storeNumber)
          prices(currency: $currency) {
            max
            min
            priceIn(currency: $currency)
            id
          }
          vendorByCountry: vendorByCountryOrGlobalZone(country: $country, globalZone: $globalZone) {
            externalId
          }
        }
      }
      optionTypes {
        ...OptionTypes
      }
      variantsIncludingMaster(number: $storeNumber, country: $country) {
        ... on Variant {
          vendorByCountry: vendorByCountryOrGlobalZone(country: $country, globalZone: $globalZone) {
            externalId
          }
          id: currentCatalogIdWithId
          externalId
          externalSource
          isMaster
          outOfStock
          amountIn(currency: $currency)
          priceIn(currency: $currency)
          optionValues {
            ...OptionValuesDetails
          }
          images(storeNumber: $storeNumber)
        }
        ... on Price {
          id
          images
          description
          amountIn(currency: $currency)
          priceIn(currency: $currency)
          displayName
          externalId
        }
      }
      type
      vendorByCountry: vendorByCountryOrGlobalZone(country: $country, globalZone: $globalZone) {
        externalId
      }
    }
  }
  ${PRODUCT_OPTION_TYPES}
  ${OPTION_VALUES}
`;
